import { render, staticRenderFns } from "./set15.vue?vue&type=template&id=447f8a67&scoped=true&"
import script from "./set15.vue?vue&type=script&lang=js&"
export * from "./set15.vue?vue&type=script&lang=js&"
import style0 from "./set15.vue?vue&type=style&index=0&id=447f8a67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447f8a67",
  null
  
)

export default component.exports